(function () {
  if (!window.CRISPS_UPSELL || !window.CRISPS_UPSELL.enabled) return;

  // Holiday upsell priority: if holiday is enabled + not shown yet, let it intercept first.
  function holidayHasPriority() {
    return (
      window.HOLIDAY_UPSELL &&
      window.HOLIDAY_UPSELL.enabled &&
      !sessionStorage.getItem("holidayUpsellShown")
    );
  }

  let pendingCheckoutClick = null;
  let bypassNextClick = false;

  // Products that mean "crisps already in cart" (ANY variant)
  const CRISPS_PRODUCT_IDS = new Set([
    7451545043041,
    7149017071713,
    7149019824225,
    7149018906721,
    7149433421921,
  ]);

  // Exclusions for adjusted total (ANY variant)
  const EXCLUDE_PRODUCT_IDS = new Set([
    6675201196129, // Gift Message
    6931762872417, // Delivery Protection
  ]);

  async function getCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  function cartHasCrisps(cart) {
    return (cart.items || []).some((item) => CRISPS_PRODUCT_IDS.has(Number(item.product_id)));
  }

  function getAdjustedTotalDollars(cart) {
    let total = Number(cart.total_price || 0);

    for (const item of (cart.items || [])) {
      if (EXCLUDE_PRODUCT_IDS.has(Number(item.product_id))) {
        total -= Number(item.final_line_price || 0);
      }
    }
    return total / 100;
  }

  function chooseMode(adjustedTotal) {
    return adjustedTotal < Number(window.CRISPS_UPSELL.threshold || 55) ? "A" : "B";
  }

  function setModalCopy(mode) {
    const h = document.getElementById("yvr-crisps-upsell-heading");
    const p = document.getElementById("yvr-crisps-upsell-body");
    const select = document.getElementById("yvr-crisps-upsell-select");
    if (!h || !p || !select) return;

    const heading = window.CRISPS_UPSELL["heading" + mode] || "";
    const line1 = window.CRISPS_UPSELL["line1" + mode] || "";
    const line2 = window.CRISPS_UPSELL["line2" + mode] || "";

    h.textContent = heading;
    p.innerHTML = `${line1}<br>${line2}`;

    // Fill dropdown labels for this mode
    const opt1 = select.querySelector('option[value="option1"]');
    const opt2 = select.querySelector('option[value="option2"]');
    if (opt1) opt1.textContent = window.CRISPS_UPSELL["option1Label" + mode] || "Option 1";
    if (opt2) opt2.textContent = window.CRISPS_UPSELL["option2Label" + mode] || "Option 2";

    // reset selection each time
    select.value = "";
  }

  function openUpsell(originalCheckoutButton) {
    pendingCheckoutClick = originalCheckoutButton;

    const modal = document.getElementById("yvr-crisps-upsell");
    if (!modal) return;

    modal.style.display = "flex";
    modal.classList.add("is-mounted");
    requestAnimationFrame(() => modal.classList.add("is-open"));
  }

  function closeUpsell() {
    const modal = document.getElementById("yvr-crisps-upsell");
    if (!modal) return;

    modal.classList.remove("is-open");
    setTimeout(() => {
      modal.classList.remove("is-mounted");
      modal.style.display = "none";
    }, 300);
  }

  function resumeCheckout() {
    closeUpsell();
    if (pendingCheckoutClick) {
      bypassNextClick = true; // prevents re-intercept loop
      pendingCheckoutClick.click();
    }
  }

  function addVariantAndCheckout(variantId) {
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(() => resumeCheckout())
      .catch(() => resumeCheckout());
  }

  document.addEventListener("DOMContentLoaded", function () {
    const addBtn = document.getElementById("yvr-crisps-upsell-add");
    const skipBtn = document.getElementById("yvr-crisps-upsell-skip");
    const select = document.getElementById("yvr-crisps-upsell-select");
    if (!addBtn || !skipBtn || !select) return;

    addBtn.addEventListener("click", function () {
      const value = select.value;
      if (!value) {
        select.classList.add("shake");
        select.addEventListener("animationend", () => select.classList.remove("shake"), { once: true });
        return;
      }

      const cartMode = select.dataset.mode || "A";
      const v1 = window.CRISPS_UPSELL["option1Variant" + cartMode];
      const v2 = window.CRISPS_UPSELL["option2Variant" + cartMode];

      if (value === "option1" && v1) return addVariantAndCheckout(v1);
      if (value === "option2" && v2) return addVariantAndCheckout(v2);

      // fail-safe
      resumeCheckout();
    });

    skipBtn.addEventListener("click", resumeCheckout);
  });

  // INTERCEPT CHECKOUT (every time)
document.addEventListener("click", async function (e) {
  const btn = e.target.closest("form.cart [type='submit']");
  if (!btn) return;

  if (bypassNextClick) {
    bypassNextClick = false;
    return;
  }

  if (holidayHasPriority()) return;

  e.preventDefault();
  e.stopImmediatePropagation();

  try {
    const cart = await getCart();

    if (cartHasCrisps(cart)) {
      bypassNextClick = true;
      btn.click();
      return;
    }

        const adjusted = getAdjustedTotalDollars(cart);

        // 🔑 FORCE MESSAGE B FOR PICKUP
        let mode = chooseMode(adjusted);

        const checkoutMethod =
        cart.attributes && cart.attributes['Checkout-Method'];

        if (checkoutMethod === 'pickup') {
        mode = 'B';
        }


    const select = document.getElementById("yvr-crisps-upsell-select");
    if (select) select.dataset.mode = mode;

    setModalCopy(mode);
    openUpsell(btn);
  } catch (err) {
    bypassNextClick = true;
    btn.click();
  }
});
})();